import { FormControl, FormHelperText,  TextField, withStyles } from "@material-ui/core";
import React, { ReactNode } from "react";
import { useIntl } from "react-intl";

interface CustomTextFieldProps {
  readonly id: string;
  readonly aria?: string;
  readonly placeholder?: string;
  readonly label?: string;
  readonly inputProps?: object;
  readonly name?: string;
  readonly fullWidth?: boolean;
  readonly state: string;
  readonly setState: (state: any) => void;
  readonly variant: "standard" | "filled" | "outlined";
  readonly autoComplete?: string;
  readonly hideText?: boolean;
  readonly isDisabled?: boolean;
  readonly endAdornment?: ReactNode;
  readonly startAdornment?: ReactNode;
  readonly helperText?: string;
  readonly pageName?: string;
}

const CssTextField = withStyles({
  root: {
    "& .MuiOutlinedInput-root": {
      height:  "47px",
      fontSize:'14px',
    },
    "& .MuiOutlinedInput-input": {
      height:  "47px",
      fontSize:'14px',
    },
    "$ .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#000 !important",
    },
  },
})(TextField);

function CustomTextField(props: CustomTextFieldProps) {
  const {
    id,
    aria,
    placeholder,
    label,
    inputProps,
    name,
    fullWidth = false,
    state,
    setState,
    variant,
    autoComplete,
    hideText,
    isDisabled,
    endAdornment,
    startAdornment,
    helperText,
  } = props;
  const intl = useIntl();
  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const { value } = event.target;
    setState(value);
   
  };
  return (
    <FormControl variant="outlined">
      <CssTextField
        id={id}
        aria-label={`${intl.formatMessage({ id: aria })}`}
        autoComplete={autoComplete}
        placeholder={placeholder}
        value={state || ""}
        inputProps={inputProps}
        label={label}
        name={name}
        fullWidth={fullWidth}
        variant={variant}
        onChange={handleChange}
        data-testid={id}
        type={hideText ? "password" : "text"}
        disabled={isDisabled}
        InputProps={{
          endAdornment: endAdornment,
          startAdornment: startAdornment,
        }}
      />
      <FormHelperText style={{ fontWeight: "400", color: "red", fontSize: "14px", margin:'0px' }}>{helperText}</FormHelperText>
    </FormControl>
  );
}

export default CustomTextField;
